













































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";
import dynamicLoadSelectTree from "@/components/custom/dynamicLoadSelectTree/index.vue";
import { productConditionFilter } from "@root/lib/common.ts";

const wt = namespace("wt");
const common = namespace("common");
const scan = namespace("scan");
@Component({ components: { dynamicLoadSelectTree } })
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class WtPrice extends Vue {
  @common.Action queryDataDictionaryListLang;

  @wt.Action priceActivitySalePriceManagement;
  @wt.Action queryBrandList;
  @wt.Action exportSalePrice;
  @scan.Action getAttr;

  // @scan.State patternList; // 花纹

  private dataList = [];
  private wtPriceBrandList = [];
  private patternList = [];

  private form = {
    priceDate: "",
    productName: "",
    productCode: "",
    productNo: "",
    brandCode: "",
    pattern: "",
    specification: "",
    categoryCode: [],
    status: ""
  };

  private activeName = "1";
  private serviceOrderStatusList = [];

  private brandOptions = [];
  private patternOptions = [];
  private specificationOptions = [];

  private searchData = null;
  private openUrl = null;
  private exportLoading = false;
  private exportVisible = false;

  get orderListComputed() {
    return this.dataList;
  }
  async mounted() {
    await this.getData();
    await this.getBrandList();
    await this.getPriceDic();
    await this.getAttrApi();
  }
  async exportPriceList() {
    (this.$refs.gtExportDialog as any).visible = true;
  }

  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum } = this as any;
    const pageInput = {
      pageSize,
      pageNum
    };
    try {
      const {
        pattern,
        specification,
        categoryCode,
        brandCode,
        productName,
        productCode,
        productNo,
        status
      } = this.form;
      let params = {
        // categoryCode,
        productName,
        productCode,
        productNo,
        status
      };
      const defaultType = {
        productName: 1,
        productCode: 1,
        productNo: 1,
        brandCode: -1,
        categoryCode: -1,
        onboardTime: 2,
        createTime: 2,
        status: 0,
        barcode: 1
      };
      // 是否有花纹
      // 是否有规格
      let attrList = [];
      // const { pattern, specification } = this.form;
      if (pattern) {
        attrList = [{ attrCode: "_pattern", attrValue: [pattern] }];
      }
      if (specification) {
        attrList = [
          [{ attrCode: "_specification", attrValue: [specification] }]
        ];
      }
      if (specification && pattern) {
        attrList = [
          [
            { attrCode: "_pattern", attrValue: [pattern] },
            { attrCode: "_specification", attrValue: [specification] }
          ]
        ];
      }
      let brandCodeList = [];
      if (brandCode) {
        brandCodeList = [brandCode];
      }
      let conditionList = [];
      for (let i in params) {
        if (
          (params[i] && JSON.stringify(params[i]) !== "[]") ||
          params[i] === 0
        ) {
          conditionList = [
            ...conditionList,
            ...productConditionFilter(i, params[i], defaultType[i])
          ];
        }
      }
      let categoryCodeList = [];
      if (categoryCode && categoryCode.length) {
        categoryCodeList = categoryCode;
      }
      conditionList = conditionList[0] ? [conditionList] : [[]];
      const requestParams = {
        locale: localStorage.getItem("localeLanguage"),
        channel: localStorage.getItem("channel"),
        orgCode: "default",
        sortList: [
          {
            name: "createTime",
            sort: 1
          }
        ],
        brandCodeList,
        attrList,
        categoryCodeList,
        conditionList: conditionList
      };
      const searchData = {
        // orgCode: localStorage.getItem("org"),
        condition: requestParams,
        pageInput
      };
      this.searchData = searchData;
      let { total, list } = await this.priceActivitySalePriceManagement(
        searchData
      );
      this.dataList = list;
      (this as any).total = total;
    } catch (err) {
      this.dataList = [];
      console.error(err);
      (this as any).total = 0;
    }
  }

  async getPriceDic() {
    this.serviceOrderStatusList = await this.queryDataDictionaryListLang({
      statePath: "wtPriceList",
      ddCode: "PRODUCT_STATUS"
    });
  }

  async getBrandList() {
    try {
      const { list, total } = await this.queryBrandList({
        pageInput: {
          pageNum: 1,
          pageSize: 1000
        },
        condition: {
          // locale: localStorage.getItem("localeLanguage") || "zh-CN",
          locale: "zh-CN",
          channel: localStorage.getItem("channel"),
          orgCode: "default",
          conditionList: [[]]
        }
      });
      this.wtPriceBrandList = list.map(({ brandName, brandCode }) => ({
        label: brandName,
        value: brandCode
      }));
    } catch (error) {
      this.wtPriceBrandList = [];
    }
  }

  selectCategory(data) {
    this.form.categoryCode = [...data];
  }

  onCreateBtnClick() {
    this.$router.push({ name: "OrderCreateMember" });
  }
  async getAttrApi() {
    const res = await this.getAttr({
      codeList: ["_pattern"],
      orgCode: "default"
    });
    this.patternList = (res && res[0] && res[0].value) || [];
  }
}
